import i18next from 'i18next';

export const getActions = (storeName, handleGlobalExport, openByStoreExportModal) => [
  {
    label: i18next.t('ANALYSIS.PURCHASES.EXPORT_ANALYSIS'),
    icon: '/images/inpulse/file-download-black-small.svg',
    handleClick: handleGlobalExport,
  },
  {
    label: i18next.t('ANALYSIS.PURCHASES.EXPORT_BY_STORE', { storeName }),
    icon: '/images/inpulse/file-download-black-small.svg',
    handleClick: () => openByStoreExportModal(false),
  },
];
